import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Content = styled.div`
  background: #fff;
  border: 1px solid #999;
  border-radius: 0.3rem;
  position: relative;
  text-align: left;
  padding-left: 1rem;
  padding-bottom: 2.5rem;
  margin-bottom: 30px;
  height: 100%;
  width: 95%;

  @media (min-width: ${props => props.theme.breakpoints.sm}px) {
    margin-left: auto;
    margin-right: auto;
    padding: 10px 40px 30px;
    width: 50%;
  }
`;

const Row = styled.div`
  display: flex;
  padding-top: 1rem;
  flex-direction: column;

  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    flex-direction: row;
  }
`;

const Label = styled.div`
  color: #999;

  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    width: 30%;
  }
`;

const Data = styled.div`
  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    width: 50%;
  }
`;

const Button = styled.button`
  background-color: #fff;
  border: 1px solid #0094ca;
  border-radius: 15px;
  bottom: 0;
  color: #0094ca;
  display: inline-block;
  font-size: 0.8em;
  left: 50%;
  margin-bottom: -15px;
  padding: 5px 20px;
  position: absolute;
  text-align: center;
  text-transform: uppercase;
  transform: translateX(-50%);
  height: 2rem;
  width: 7rem;
  cursor: pointer;

  &:focus {
    outline: 0;
  }
`;

const SummaryPanel = ({ data, editUrl }) => {
  const navigate = useNavigate();
  const onClick = () => {
    const isEditUrlAString = typeof editUrl === 'string';
    if (editUrl) {
      if (isEditUrlAString) {
        return navigate(editUrl);
      }

      return editUrl();
    }

    return null;
  };

  return (
    <Content>
      {data?.map(x => (
        <Row key={x.label}>
          <Label>{x.label}:</Label>

          <Data>{x.data}</Data>
        </Row>
      ))}

      {editUrl && <Button onClick={() => onClick()}>Edit {'>'}</Button>}
    </Content>
  );
};

SummaryPanel.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      data: PropTypes.node
    })
  ).isRequired,
  push: PropTypes.func.isRequired,
  editUrl: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string,
    PropTypes.bool
  ])
};

SummaryPanel.defaultProps = {
  editUrl: null
};

export default SummaryPanel;
